<main class="flow-template" fxLayout="column" fxLayoutGap="24px">
  <section class="flow-template-header" fxLayout fxLayoutAlign="space-between center">
    <div>
      <img *ngIf="showLogo" class="sbnb-logo" src="/assets/images/logo-transparent-dark.svg" alt="Hospitable logo" />
    </div>
    <div>
      <sbnb-close [border]="true" (click)="close()"></sbnb-close>
    </div>
  </section>

  <div fxFlex fxLayout="row" fxLayoutAlign="center center">
    <router-outlet></router-outlet>
  </div>
</main>
